import axios, { AxiosRequestConfig } from "axios";

import { API_URLS } from "src/utils/API_URLS";
import asyncWrapper from "src/utils/asyncWrapper";

const ProjectsService = {
  updateMetaValue: async <T>(
    data: T,
    config?: AxiosRequestConfig,
  ): Promise<void> => {
    return asyncWrapper(async () => {
      const url = API_URLS.updateProjectMetaValue;
      await axios.put(url, data, config);
    });
  },
};

export default ProjectsService;
